var React = require('react');

function Tool (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"none","stroke":"#009ae1","strokeWidth":"1.242","d":"M24.4 25.3v9H.6V10h7.9","key":0}),React.createElement("path",{"fill":"#009ae1","d":"M3.7 16.4h4.9v-1.3H3.7v1.3zm0 6.8h8.8v-1.3H3.7v1.3zm0 6.7h17.7v-1.3H3.7v1.3z","key":1}),React.createElement("path",{"fill":"none","stroke":"#005BA2","strokeWidth":"1.284","d":"M38.7 28.2l-7.6-7.6-2.3 2.3 7.6 7.6c.6.6 1.7.6 2.3 0 .6-.7.6-1.7 0-2.3z","key":2}),React.createElement("path",{"fill":"none","stroke":"#005BA2","strokeWidth":"1.284","d":"M33.1 13.3c0 6.9-5.5 12.5-12.4 12.5-6.8 0-12.4-5.6-12.4-12.4S13.9.9 20.7.9s12.4 5.6 12.4 12.4z","key":3}),React.createElement("path",{"fill":"none","stroke":"#009ae1","strokeWidth":"1.242","d":"M13.7 18.5h2.7v-5.7h-2.7v5.7zm5.3 0h2.7V9.9H19v8.6zm5.3 0H27V7.1h-2.7v11.4z","key":4})]);
}

Tool.displayName = "Tool";

Tool.defaultProps = {"viewBox":"0 0 40 36"};

module.exports = Tool;

Tool.default = Tool;
